'use strict';

import { infobox } from './modules/infobox';
import { header } from './modules/header';
import { gravityFormsCustomizations } from './modules/gravityFormsCustomizations';
import { navigation } from './modules/navigation';
// import { googleMapsCustomizations } from './modules/googleMapsCustomizations';
import { splideCustomizations } from './modules/splideCustomizations';

splideCustomizations.init(); // Muss vor DOMContentLoaded ausgeführt werden

document.addEventListener('DOMContentLoaded', () => {
	header.init();
	navigation.init();
	infobox.init();
	// googleMapsCustomizations.init();
	gravityFormsCustomizations.init();
});
